var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCondiciones03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2105 1.7393L16.8636 14.6674L2.66322 16.7472C0.116682 17.1183 -0.903878 20.2722 0.942848 22.0786L11.2165 32.1359L8.78657 46.3432C8.34919 48.9112 11.0415 50.8348 13.2965 49.6338L26 42.9256L38.7035 49.6338C40.9585 50.825 43.6508 48.9112 43.2134 46.3432L40.7835 32.1359L51.0572 22.0786C52.9039 20.2722 51.8833 17.1183 49.3368 16.7472L35.1364 14.6674L28.7895 1.7393C27.6523 -0.565098 24.3574 -0.594392 23.2105 1.7393Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondiciones03);
export default __webpack_public_path__ + "static/media/Condiciones03.21278e73c6973cd3b43d991033fa2890.svg";
export { ForwardRef as ReactComponent };